import React, { useState, useEffect } from "react";
import ShimmerScreen from "../../../../Layouts/ShimmerScreen";
import { useTranslation } from "react-i18next";
import {
  GetMasterIndustryData,
  GetMasterIndustryDataResClear,
} from "../../../../../redux/coaching/actions";
import { useDispatch, useSelector } from "react-redux";
import { SessionKeys } from "../../../../../utils/AppUtils";
import _ from "lodash";
import NotFoundComponent from "../../../NotFound/NotFoundComponent";
import NotFoundImage from "../../../NotFound/NotFoundImage";
import { useNavigate } from "react-router-dom";

const IndustriesListing = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [industriesData, setIndustriesData] = useState([]);

  const industryListingRes = useSelector(
    (state) => state.coaching.getMasterIndustryData
  );

  let naviagte = useNavigate();

  useEffect(() => {
    callIndustriesAPI();
    return () => {
      dispatch(GetMasterIndustryDataResClear());
    };
  }, []);

  const callIndustriesAPI = () => {
    setIsLoading(true);
    dispatch(
      GetMasterIndustryData({
        module: "masterIndustryData",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coaching_service",
        },
      })
    );
  };

  useEffect(() => {
    console.log("indus--", industryListingRes);
    if (!_.isEmpty(industryListingRes)) {
      if (industryListingRes?.status === "success") {
        let data = industryListingRes?.payload?.payload;
        setIndustriesData(data);
        setIsLoading(false);
      } else {
        setIndustriesData([]);
        setIsLoading(false);
      }
    }
  }, [industryListingRes]);

  const navigateToCoachingServicesListing = (industry_ids) => {
    const params = new URLSearchParams(window.location.search);
    let industries = [];
    industries.push(industry_ids);

    params.delete("tab");
    params.set("industries", encodeURIComponent(industries?.join(",")));
    naviagte(`/learn/coachingservices?tab=5&${params.toString()}`);
  };

  return (
    <>
      <div className="container">
        <div className="row mt-2">
          <div className="col-12">
            <h3 className="mentor-title mb-0">{t("Coaching Services")}</h3>
          </div>
          <div className="councoa d-flex justify-content-start mt-3 mb-4">
            {t("Choose one or more industry to view coaching services")}
          </div>
        </div>
        <div className="row g-3">
          {isLoading ? (
            [1, 2, 3, 4, 5, 6, 7, 8]?.map((item) => (
              <>
                <div className="col-3 mt-3">
                  <div className=" text-center align-items-center">
                    <div>
                      <ShimmerScreen case="rect" height="8rem" width="100%" />
                    </div>
                    <div>
                      <ShimmerScreen case="rect" height="1.5rem" width="100%" />
                    </div>
                  </div>
                </div>
              </>
            ))
          ) : !_.isEmpty(industriesData) ? (
            industriesData?.map((item, i) => {
              return (
                <div className="col-3">
                  <div
                    className="coach-box text-center align-items-center cursor-pointer indusbox"
                    onClick={() => navigateToCoachingServicesListing(item?.id)}
                  >
                    <div className="imgbox-in">
                      <img src={item?.image} alt={item?.name} />
                    </div>
                    <div className="indutext">
                      <strong> {item?.name}</strong>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="not-found cart-notfound">
              <div className="interboxes">
                <NotFoundImage width={200} height={200} />
                <p>{t("No Industries Found.")}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default IndustriesListing;
